
const SearchIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.3311 19.0695L17.7842 14.3634C17.6522 14.2533 17.4905 14.1938 17.3264 14.1938C17.097 14.1938 16.8786 14.3094 16.7422 14.503C16.111 15.3982 15.337 16.1727 14.4416 16.8046C14.275 16.9222 14.1646 17.102 14.1389 17.2981C14.1131 17.4943 14.1704 17.6883 14.3004 17.8442L19.0094 23.396C19.3286 23.7789 19.7918 23.9999 20.2786 23.9999C20.7162 23.9999 21.1329 23.8241 21.4522 23.5049L23.4427 21.5144C23.7819 21.1751 23.957 20.7324 23.936 20.2675C23.9147 19.8024 23.6999 19.3769 23.3311 19.0695Z"
        fill={props?.color ?? "#2558BC"}
      />
      <path
        d="M8.87574 17.6272C11.2297 17.6272 13.443 16.7104 15.1078 15.0457C16.7726 13.3809 17.6893 11.1677 17.6893 8.81361C17.6893 3.95383 13.7356 0 8.87574 0C4.01585 0 0.0622559 3.95383 0.0622559 8.81361C0.0622559 13.6734 4.01597 17.6272 8.87574 17.6272ZM2.91841 8.81361C2.91841 5.5287 5.59084 2.85628 8.87574 2.85628C12.1607 2.85628 14.833 5.5287 14.833 8.81361C14.833 10.4023 14.2128 11.8975 13.0863 13.024C11.9597 14.1504 10.4644 14.7708 8.87574 14.7708C5.59084 14.7709 2.91841 12.0985 2.91841 8.81361Z"
        fill={props?.color ?? "#2558BC"}
      />
    </svg>
  );
};
 
export default SearchIcon;

